import {
  defaultFormImages,
  embedColorCode,
  orderedSizeLimitListJumboForms,
  freeUsersSizeLimitListJumboForms,
  subscribersSizeLimitListJumboForms,
  businessSizeLimitListJumboForms,
  premiumSizeLimitListJumboForms,
} from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import config from "config";
import getAsyncImage from "utils/getAsyncImage";

export const calculateBodyJumboForm = async ({
  body,
  lang,
  includeFooter,
  hideHeader,
  setState,
}) => {
  //api request
  const params = {
    body: body,
    lang: lang,
    includeFooter: includeFooter,
    hideHeader: hideHeader,
  };
  const response = await apiRequest(
    "EmbedDynamics",
    "CalculateBodyJumboForm",
    params
  );
  if (response.status === "success") {
    if (response.data) {
      setState(response.data);
    }
  }
};

export const ImportUserForm = ({
  EmbedForm,
  isPremium,
  isBusiness,
  isSubscribed,
  EmbedFooterLinksList,
  setLinkFooters,
  setDisplayFooterLinks,
  setIsCheckedPreventDisplayForm,
  setListDomains,
  setEditCustomFooterLinks,
  setFormId,
  setOldFormId,
  setFormWidth,
  setFormHeight,
  setFormLanguage,
  setFormDisplayTitle,
  setFormDescription,
  setFormImage,
  setFormJson,
  setEmailToReceiveFiles,
  setUploadFilesLimit,
  setFileSizeLimit,
  setManuallyDeleteCheckbox,
  setAutomaticallyDeleteCheckbox,
  setDaysToDelete,
  setPotentialCustomers,
  setCustomersFilesDownloaded,
  setOrderConfirmation,
  setDisplayLink,
  setDisplaySendAnotherEmail,
  setThankyouPageRedirect,
  setRedirectLink,
  setProtectFormWithPassword,
  setPasswordForm,
  setAllowFolowingFormatsCheckbox,
  setDenyForamtsCheckbox,
  setUploadAnyFormatsCheckbox,
  setFileFormats,
  setFormButtonsColor,
  setFormButtonTextColor,
  setFormBackgroundColor,
  setHideEmbedImage,
  setWebsiteURL,
  setHideDescription,
  setHideTitle,
  setShowDescription,
  setShowImage,
  setShowTitle,
  setDirectionForm,
  setAllowAccess,
  setDisplayToSubUsers,
  setSendEmailToRecipients,
  setFormMaxHeight,
  setDeleteMailLink,
  setDisplayTypeSubUsers,
}) => {
  if (EmbedFooterLinksList) {
    let tempFooter = [];
    EmbedFooterLinksList &&
      EmbedFooterLinksList.EmbedFooterLinksList.map(
        (item, i) =>
          item &&
          tempFooter.push({
            FooterLinkTitle: item.FooterTitle,
            FooterLinkUrl: item.FooterUrl,
          })
      );
    setLinkFooters(tempFooter);
  }
  setDisplayFooterLinks(
    isPremium() ? EmbedForm.Embed_Dynamic_Display_Footer_Links : false
  );
  setEditCustomFooterLinks(EmbedForm.Embed_Dynamic_Custom_Footer_Links);
  setFormId(EmbedForm.Embed_Dynamic_Id);
  setOldFormId(EmbedForm.Embed_Dynamic_Id);
  setFormWidth(EmbedForm.Embed_Dynamic_Width);
  setFormMaxHeight(EmbedForm.Embed_Dynamic_Max_Height);
  setFormHeight(EmbedForm.Embed_Dynamic_Height);
  setFormLanguage(EmbedForm.Embed_Dynamic_Culture);
  setFormDisplayTitle(EmbedForm.Embed_Dynamic_Inner_Title);
  setDirectionForm(
    EmbedForm.Embed_Dynamic_Culture === "he-IL" ||
      EmbedForm.Embed_Dynamic_Culture === "ar-SA"
      ? "rtl"
      : "ltr"
  );
  setFormDescription(
    EmbedForm.Embed_Dynamic_Description
      ? EmbedForm.Embed_Dynamic_Description
      : ""
  );
  if (EmbedForm?.DisplayOnlyOnDomains) {
    setIsCheckedPreventDisplayForm(EmbedForm?.DisplayOnlyOnDomains);
    if (EmbedForm?.ListedDomains) {
      setListDomains(EmbedForm.ListedDomains);
    }
  }
  if (
    EmbedForm.Embed_Dynamic_Image &&
    EmbedForm.Embed_Dynamic_Image.EmbedDynamicFormImageLogicalPath
  ) {
    if (EmbedForm.Embed_Dynamic_Image_Url) {
      setFormImage(EmbedForm.Embed_Dynamic_Image_Url);
    }
  } else {
    if (EmbedForm.Embed_Dynamic_Image_Url) {
      if (
        EmbedForm.Embed_Dynamic_Image_Url.includes(
          `${config.api.resource}/assets/images/picker/picker-app.png`
        )
      ) {
        setFormImage(EmbedForm.Embed_Dynamic_Image_Url);
      } else {
        getAsyncImage(
          `images/personal/form-images/webp/${EmbedForm.Embed_Dynamic_Image_Url}.webp`,
          setFormImage
        );
      }
    } else {
      let randNum = Math.floor(Math.random() * 18);
      getAsyncImage(`images/${defaultFormImages[randNum]}.webp`, setFormImage);
    }
  }

  setFormJson(JSON.parse(EmbedForm.Embed_Dynamic_Body));
  let recipients = EmbedForm.Embed_Dynamic_Recipients
    ? EmbedForm.Embed_Dynamic_Recipients
    : "";
  if (EmbedForm.Embed_Dynamic_Recipients) {
    if (EmbedForm.Embed_Dynamic_Recipients.includes(",")) {
      let tempString = "";
      let tempArray = EmbedForm.Embed_Dynamic_Recipients.split(",");
      for (let i = 0; i < tempArray.length; i++) {
        const element = tempArray[i];
        tempString += element.trim();
        if (i < tempArray.length - 1) {
          tempString += ",";
        }
      }
      recipients = tempString;
    }
  }

  setEmailToReceiveFiles(recipients);
  setUploadFilesLimit(
    isPremium() || isBusiness()
      ? EmbedForm.Embed_Dynamic_Upload_Files_limit
        ? EmbedForm.Embed_Dynamic_Upload_Files_limit
        : 0
      : 0
  );
  let newNum = EmbedForm.Embed_Dynamic_Size_Id;
  const currentSizeId = orderedSizeLimitListJumboForms.filter(
    (item) => item.id === newNum
  )[0];
  const currentSizeLength =
    orderedSizeLimitListJumboForms.indexOf(currentSizeId);
  const maxSizeForPremium =
    orderedSizeLimitListJumboForms[premiumSizeLimitListJumboForms];
  const maxSizeForPremiumLength =
    orderedSizeLimitListJumboForms.indexOf(maxSizeForPremium);
  if (!isPremium()) {
    //get the current size where id in orderedSizeLimitListJumboForms is newNum
    const maxSizeForBusiness =
      orderedSizeLimitListJumboForms[businessSizeLimitListJumboForms];
    const maxSizeForBusinessLength =
      orderedSizeLimitListJumboForms.indexOf(maxSizeForBusiness);
    const maxSizeForProId =
      orderedSizeLimitListJumboForms[subscribersSizeLimitListJumboForms];
    const maxSizeForProLength =
      orderedSizeLimitListJumboForms.indexOf(maxSizeForProId);
    const maxSizeForFreeId =
      orderedSizeLimitListJumboForms[freeUsersSizeLimitListJumboForms];
    const maxSizeForFreeLength =
      orderedSizeLimitListJumboForms.indexOf(maxSizeForFreeId);
    if (isSubscribed()) {
      if (isBusiness()) {
        if (currentSizeLength > maxSizeForBusinessLength) {
          newNum = maxSizeForBusiness.id;
        }
      } else {
        if (currentSizeLength > maxSizeForProLength) {
          newNum = maxSizeForProId.id;
        }
      }
    } else {
      if (currentSizeLength > maxSizeForFreeLength) {
        newNum = maxSizeForFreeId.id;
      }
    }
  } else {
    if (currentSizeLength > maxSizeForPremiumLength) {
      newNum = maxSizeForPremium.id;
    }
  }
  setFileSizeLimit(newNum);
  setManuallyDeleteCheckbox(EmbedForm.Embed_Dynamic_Manually_Delete);
  setAutomaticallyDeleteCheckbox(!EmbedForm.Embed_Dynamic_Manually_Delete);
  setDaysToDelete(
    isSubscribed()
      ? isPremium()
        ? EmbedForm.Embed_Dynamic_Delete_Days &&
          EmbedForm.Embed_Dynamic_Delete_Days !== undefined
          ? EmbedForm.Embed_Dynamic_Delete_Days
          : 3
        : 3
      : 2
  );

  setPotentialCustomers(EmbedForm.Embed_Dynamic_Send_Lead);
  setCustomersFilesDownloaded(EmbedForm.Embed_Dynamic_Send_Download);
  setOrderConfirmation(EmbedForm.Embed_Dynamic_Send_Copy);
  if (EmbedForm.Embed_Dynamic_Send_Mail_Recipients !== null) {
    setSendEmailToRecipients(EmbedForm.Embed_Dynamic_Send_Mail_Recipients);
  }
  setDisplayLink(EmbedForm.Embed_Dynamic_End_Download_Link);
  setDisplaySendAnotherEmail(EmbedForm.Embed_Dynamic_End_Send_Button);
  setThankyouPageRedirect(EmbedForm.Embed_Dynamic_End_Redirect);
  setRedirectLink(EmbedForm.Embed_Dynamic_End_Redirect_Url);

  if (EmbedForm.Embed_Dynamic_SetPassword) {
    if (EmbedForm.Embed_Dynamic_Password) {
      setProtectFormWithPassword(EmbedForm.Embed_Dynamic_SetPassword);
      EncryptOrDecryptAESPassword({
        password: EmbedForm.Embed_Dynamic_Password,
        setPasswordForm: setPasswordForm,
      });
    }
  }
  setAllowAccess(EmbedForm.Embed_Dynamic_Allow_Access);
  setAllowFolowingFormatsCheckbox(
    EmbedForm.Embed_Dynamic_Formats_Action &&
      EmbedForm.Embed_Dynamic_Formats_Action.toLowerCase() === "only"
      ? true
      : false
  );
  setDenyForamtsCheckbox(
    EmbedForm.Embed_Dynamic_Formats_Action &&
      EmbedForm.Embed_Dynamic_Formats_Action.toLowerCase() === "exclude"
      ? true
      : false
  );
  setUploadAnyFormatsCheckbox(EmbedForm.Embed_Dynamic_Formats ? false : true);
  setFileFormats(EmbedForm.Embed_Dynamic_Formats);
  setWebsiteURL(EmbedForm.Embed_Dynamic_Url ? EmbedForm.Embed_Dynamic_Url : "");
  let colorButton = embedColorCode;
  let coolorBackground = "#FFFFFF";
  let colorTextButton = "#FFFFFF";
  if (EmbedForm.Embed_Dynamic_Buttons_Color_Code) {
    colorButton = EmbedForm.Embed_Dynamic_Buttons_Color_Code.includes("#")
      ? EmbedForm.Embed_Dynamic_Buttons_Color_Code
      : "#" + EmbedForm.Embed_Dynamic_Buttons_Color_Code;
  }
  if (EmbedForm.Embed_Dynamic_Background_Color_Code) {
    coolorBackground = EmbedForm.Embed_Dynamic_Background_Color_Code.includes(
      "#"
    )
      ? EmbedForm.Embed_Dynamic_Background_Color_Code
      : "#" + EmbedForm.Embed_Dynamic_Background_Color_Code;
  }
  if (EmbedForm.Embed_Dynamic_Button_Text_Color_Code) {
    colorTextButton = EmbedForm.Embed_Dynamic_Button_Text_Color_Code.includes(
      "#"
    )
      ? EmbedForm.Embed_Dynamic_Button_Text_Color_Code
      : "#" + EmbedForm.Embed_Dynamic_Button_Text_Color_Code;
  }
  setFormButtonTextColor(colorTextButton);
  setFormButtonsColor(colorButton);
  setFormBackgroundColor(coolorBackground);

  setShowImage(
    EmbedForm.Embed_Dynamic_Hide_Image !== null
      ? EmbedForm.Embed_Dynamic_Hide_Image
      : true
  );
  setShowDescription(
    EmbedForm.Embed_Dynamic_Hide_Description !== null
      ? EmbedForm.Embed_Dynamic_Hide_Description
      : true
  );
  setShowTitle(
    EmbedForm.Embed_Dynamic_Hide_Title !== null
      ? EmbedForm.Embed_Dynamic_Hide_Title
      : true
  );

  setDisplayToSubUsers(
    EmbedForm.Embed_Dynamic_Display_To_Sub_Users !== null
      ? EmbedForm.Embed_Dynamic_Display_To_Sub_Users
      : false
  );

  setDeleteMailLink(
    EmbedForm.Embed_Dynamic_Delete_Mail_Link !== null
      ? EmbedForm.Embed_Dynamic_Delete_Mail_Link
      : false
  );

  setDisplayTypeSubUsers(
    EmbedForm.DisplayTypeSubUsers !== null
      ? EmbedForm.DisplayTypeSubUsers
      : "All"
  );
};

//encrypt form password
export const EncryptOrDecryptAESPassword = async ({
  password,
  setPasswordForm,
}) => {
  if (password) {
    const parameters = {
      EmbedDynamicPassword: password,
      ifEncrypt: false,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "EncryptOrDecryptAESPassword",
      parameters
    );
    if (response.status === "success") {
      setPasswordForm(response.data);
    } else {
      setPasswordForm("");
    }
  } else {
    setPasswordForm("");
  }
};

//Create embed dynamic form
export const createEmbedDynamicFormReact = async ({
  body,
  formId,
  pathLang,
}) => {
  const response = await apiRequest(
    "EmbedDynamics",
    "CreateEmbedDynamicFormReact",
    body,
    "POST"
  );
  if (response.status === "success") {
    if (response.data) {
      if (response.data.resultCode === 0) {
        if (formId && formId > 0) {
        } else {
          window.location.href =
            config.baseurl +
            pathLang +
            "create-form/" +
            response.data.form.EmbedForm.Embed_Dynamic_Id;
        }
      }
    }
  }
  return response;
};
